import axios from "axios";

export const fetchApi = axios.create({
  // baseURL: "https://api.khadimwelfarefoundation.com/api/",
  baseURL:process.env.REACT_APP_API_URL,
  headers: { "Content-Type": "application/json" },
});


